import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {BaseBadgeDirective} from "./base-badge.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [BaseBadgeDirective],
  exports: [BaseBadgeDirective]
})
export class BaseBadgeModule {}
